import { Typography } from "antd";
import { twMerge } from "tailwind-merge";

export default function HelperText({ children, type = "", className = "" }) {
    return <Typography.Text className={twMerge("text-xs pl-2 font-medium block mt-1", className)} type={type}>{children}</Typography.Text>
}